import { j as e } from "../../../../../../../jsx-runtime.BREq8dyb.js";
import { PermutiveServiceProvider as s } from "@decentriq/graphql/dist/enums";
import { faInfoCircle as S, faFileLines as O } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon as g } from "@fortawesome/react-fontawesome";
import { Stack as q, Box as y, Tooltip as P, Link as C, FormControl as k, FormLabel as I, Select as A, Option as B, ListItemDecorator as D, FormHelperText as F, Typography as R, Input as K } from "@mui/joy";
import { memo as z, useEffect as H, Fragment as o } from "react";
import { b as M, C as w } from "../../../../../../../react-hook-form.Du3weLRK.js";
import { S as T, d as x } from "../../../../../../../index.BRz-o-Vs.js";
import r from "../../../../DqDatasetSyncControlledInput/DqDatasetSyncControlledInput.js";
import N from "../../../../DqDatasetSyncIcon/DqDatasetSyncIcon.js";
import { g as V } from "../../../../../../../index._aEPM5Ps.js";
import W from "../../labels/ConfigurationLabel/ConfigurationLabel.js";
import X from "../../labels/CredentialsLabel/CredentialsLabel.js";
const $ = z(({
  syncDirection: h
}) => {
  const {
    control: v,
    watch: L,
    setError: E,
    clearErrors: l,
    setValue: i
  } = M(), n = L("permutive.serviceProvider", s.GoogleCloudStorage), j = n === s.S3, f = n === s.GoogleCloudStorage, d = h === T.IMPORT, a = h === T.EXPORT;
  return H(() => {
    n === s.GoogleCloudStorage ? (i("permutive.configuration.aws", void 0), i("permutive.credentials.aws", void 0), l("permutive.configuration.aws"), l("permutive.credentials.aws")) : n === s.S3 && (i("permutive.configuration.gcs", void 0), i("permutive.credentials.gcs", void 0), l("permutive.configuration.gcs"), l("permutive.credentials.gcs"));
  }, [n, l, i]), /* @__PURE__ */ e.jsxs(q, { children: [
    /* @__PURE__ */ e.jsx(W, {}),
    a ? /* @__PURE__ */ e.jsxs(o, { children: [
      /* @__PURE__ */ e.jsx(r, { label: "Permutive API key", name: "permutive.credentials.apiKey", placeholder: 'e.g. "e26272e-ab1e-4254-b35a-3d225f9dca56"', type: "masked" }),
      /* @__PURE__ */ e.jsx(r, { label: "Segment name", name: "permutive.segmentName", placeholder: 'e.g. "Data Clean Room"' }),
      /* @__PURE__ */ e.jsx(r, { label: "Segment code", name: "permutive.segmentCode", placeholder: 'e.g. "1234"' }),
      /* @__PURE__ */ e.jsx(r, { label: /* @__PURE__ */ e.jsxs(o, { children: [
        "Import ID",
        /* @__PURE__ */ e.jsx(y, { ml: 0.5, children: /* @__PURE__ */ e.jsx(P, { title: /* @__PURE__ */ e.jsxs("span", { children: [
          "Please check the",
          " ",
          /* @__PURE__ */ e.jsx(C, { href: "https://support.permutive.com/hc/en-us/articles/360012495920-Audience-Import-Send-Segments-to-Permutive", rel: "noreferrer", target: "_blank", children: "Permutive documentation" }),
          " ",
          "for more details about importing."
        ] }), children: /* @__PURE__ */ e.jsx(g, { icon: S }) }) })
      ] }), name: "permutive.importId", placeholder: 'e.g. "ffedc3c9-d8fd-48f2-9719-12bfa83eb30d8"' })
    ] }) : null,
    /* @__PURE__ */ e.jsx(w, { control: v, name: "permutive.serviceProvider", render: ({
      field: {
        disabled: p,
        value: b = "",
        ...c
      },
      fieldState: {
        error: m
      },
      formState: {
        isSubmitting: u
      }
    }) => /* @__PURE__ */ e.jsxs(k, { disabled: a || p || u, error: !!m, required: !0, children: [
      /* @__PURE__ */ e.jsx(I, { children: "Cloud service Provider" }),
      /* @__PURE__ */ e.jsx(A, { renderValue: (t) => t ? /* @__PURE__ */ e.jsxs(o, { children: [
        /* @__PURE__ */ e.jsx(D, { children: /* @__PURE__ */ e.jsx(N, { syncType: t.value }) }),
        x[t.value]
      ] }) : null, slotProps: {
        listbox: {
          sx: {
            "--ListItemDecorator-size": "32px"
          }
        }
      }, sx: {
        "--ListItemDecorator-size": "32px"
      }, ...c, onChange: (t, G) => c.onChange(G), value: a ? s.GoogleCloudStorage : b, children: Object.values(s).map((t) => /* @__PURE__ */ e.jsxs(B, { label: x[t], value: t, children: [
        /* @__PURE__ */ e.jsx(D, { children: /* @__PURE__ */ e.jsx(N, { syncType: t }) }),
        x[t]
      ] }, t)) }),
      /* @__PURE__ */ e.jsx(F, { children: m?.message })
    ] }) }, "permutive.serviceProvider"),
    j ? /* @__PURE__ */ e.jsxs(o, { children: [
      /* @__PURE__ */ e.jsx(r, { label: "Bucket name", name: "permutive.configuration.aws.bucket", placeholder: 'e.g. "my-bucket-name"' }),
      /* @__PURE__ */ e.jsx(r, { label: "Region code", name: "permutive.configuration.aws.region", placeholder: 'e.g. "eu-central-2"' })
    ] }) : null,
    f || a ? /* @__PURE__ */ e.jsx(r, { label: "Bucket name", name: `permutive${d ? ".configuration." : "."}gcs.bucketName`, placeholder: 'e.g. "bucket-name"' }) : null,
    a ? /* @__PURE__ */ e.jsx(r, { label: "Object name", name: "permutive.gcs.objectName", placeholder: 'e.g. "object-name"' }) : null,
    d ? /* @__PURE__ */ e.jsxs(o, { children: [
      /* @__PURE__ */ e.jsxs(R, { alignItems: "center", display: "flex", gap: 0.75, level: "title-md", children: [
        /* @__PURE__ */ e.jsx(g, { icon: O }),
        /* @__PURE__ */ e.jsx("span", { children: "Publisher datasets" })
      ] }),
      /* @__PURE__ */ e.jsx(r, { label: "Matching dataset", name: "permutive.datasets.matchingDatasetName", placeholder: 'e.g. "matching.csv"' }),
      /* @__PURE__ */ e.jsx(r, { label: "Segments dataset", name: "permutive.datasets.segmentsDatasetName", placeholder: 'e.g. "segments.csv"' }),
      /* @__PURE__ */ e.jsx(r, { label: "Demographics dataset", name: "permutive.datasets.demographicsDatasetName", placeholder: 'e.g. "demographics.csv"', required: !1 })
    ] }) : null,
    /* @__PURE__ */ e.jsx(X, {}),
    j ? /* @__PURE__ */ e.jsxs(o, { children: [
      /* @__PURE__ */ e.jsx(r, { label: "Access key", name: "permutive.credentials.aws.accessKey", placeholder: 'e.g. "5JG8C6HNDPQF7W2X3Y1Z"', type: "masked" }),
      /* @__PURE__ */ e.jsx(r, { label: "Secret key", name: "permutive.credentials.aws.secretKey", placeholder: 'e.g. "F57yT3QaX2nD8jHr4KlP9cVs1W6zU0E2sY8hN4bM"', type: "masked" })
    ] }) : null,
    f || a ? /* @__PURE__ */ e.jsx(w, { control: v, name: `permutive${d ? ".credentials." : "."}gcs.credentials`, render: ({
      field: {
        disabled: p,
        value: b = "",
        ...c
      },
      fieldState: {
        error: m
      },
      formState: {
        isSubmitting: u
      }
    }) => /* @__PURE__ */ e.jsxs(k, { disabled: p || u, error: !!m, required: !0, children: [
      /* @__PURE__ */ e.jsxs(I, { children: [
        "Service account key in JSON format",
        /* @__PURE__ */ e.jsx(y, { ml: 0.5, children: /* @__PURE__ */ e.jsx(P, { title: /* @__PURE__ */ e.jsxs("span", { children: [
          "Please",
          " ",
          /* @__PURE__ */ e.jsx(C, { href: "https://cloud.google.com/iam/docs/keys-create-delete#creating", rel: "noreferrer", target: "_blank", children: "follow the instructions" }),
          " ",
          "to obtain a service account key"
        ] }), children: /* @__PURE__ */ e.jsx(g, { icon: S }) }) })
      ] }),
      /* @__PURE__ */ e.jsx(K, { ...c, disabled: p || u, slotProps: V((t) => E(c.name, t)) }),
      /* @__PURE__ */ e.jsx(F, { children: m?.message })
    ] }) }, `permutive${d ? ".credentials." : "."}gcs.credentials`) : null
  ] });
});
$.displayName = "PermutiveFormControls";
export {
  $ as default
};
//# sourceMappingURL=PermutiveFormControls.js.map
